import React, {Component, useEffect} from 'react';
import './assets/css/custom.css'

import {Route, Switch} from "react-router-dom";
//import Home from "./Pages/Home";
import Home from "./Pages/HomeV3";
//import Product from "./Pages/Product";
//import Product from "./Pages/ProductV3";
import Product from "./Pages/ProductV4";
//import Cart from "./Pages/CartV3";
import Cart from "./Pages/CartV4";
import OrderAddress from "./Pages/OrderAddressV3";
// import Payment from "./Pages/PaymentV3";
import Payment from "./Pages/PaymentV4";
// import Invoice from "./Pages/InvoiceV3";
import Invoice from "./Pages/InvoiceV4";
import Contact from "./Pages/Contact";
import Profile from "./Pages/Profile";
import Orders from "./Pages/Orders";
import Addresses from "./Pages/AddressesV3";
import OrderShow from "./Pages/OrderShow";
import Article from "./Pages/Article";
import {Toaster} from 'react-hot-toast'

/*import {messaging} from './firebase';
import {getToken} from 'firebase/messaging';*/


function App() {
    /*useEffect(() => {
        requestNotificationPermission();
    }, []);*/

    /*const requestNotificationPermission = async () => {
        try {
            const permission = await Notification.requestPermission();
            if (permission === "granted") {
                const token = await getToken(messaging);
                localStorage.setItem('stFcmToken', token);
            }
            console.log("notification permission " + permission);
        } catch (error) {
            console.log('error getting fcm token', error);
        }
    };*/
    return (
        <>
            <Switch>
                <Route path="/" exact component={Home}/>
                <Route path="/branch/:branch/product" exact component={Product}/>
                <Route path="/cart" exact component={Cart}/>
                <Route path="/address" exact component={OrderAddress}/>
                <Route path="/payment" exact component={Payment}/>
                <Route path="/invoice" exact component={Invoice}/>
                <Route path="/contact" exact component={Contact}/>
                <Route path="/profile" exact component={Profile}/>
                <Route path="/order" exact component={Orders}/>
                <Route path="/addresses" exact component={Addresses}/>
                <Route path="/order/:order" exact component={OrderShow}/>
                <Route path="/article" exact component={Article}/>
            </Switch>

            <Toaster
                position="bottom-center"
                reverseOrder={false}
                gutter={8}
                toastOptions={{
                    duration: 3000,
                    style: {
                        fontSize: '14px',
                        textAlign: 'right',
                    }
                }}
            />
        </>
    )
}

export default App;